import { Panel } from '../ui/Panel';
import { ContentEditor } from '../ui/ContentEditor';
import { useSettings } from './useSettings';

/** Instellingen › Vindbaarheid & pers › Pers. */
export function PressSettings() {
  const {
    json
  } = useSettings();
  return <Panel title="Pers" description="Logo’s en vermeldingen in de persstrook." data-id="element-4062" data-mp="2fg0pquxcw1ec">
      <ContentEditor {...json('press')} data-id="element-4063" data-mp="2keln8ml846z3" />
    </Panel>;
}